import { gql } from "@apollo/client";
import {
  LayoutDeepNestingFragment,
  LayoutNodeDeepNestingFragment,
  LayoutNodeLinkDeepNestingFragment,
  LayoutNodeFilterDeepNestingFragment,
  PaginatedListMetaNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { Layout as LayoutEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import LayoutModel from "../../data/model/Layout";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { pageQuery } from "../page-query";

const layoutsQuery = gql`
  ${LayoutNodeLinkDeepNestingFragment}
  ${LayoutNodeFilterDeepNestingFragment}
  ${LayoutNodeDeepNestingFragment}
  ${LayoutDeepNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
query GetLayouts(${listVariables}) {
    layouts(${listOptions}) {
        items {
           ...LayoutDeepNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const layoutDefinition = new EntityResourceDefinition<
  LayoutEntity,
  LayoutModel
>({
  entity: "layouts",
  query: layoutsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.terminalId = fetchedEntity.terminalId;
  },
  fetchEntities: (options) => {
    return pageQuery(client, "layouts", layoutsQuery, options);
  },
});
